// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Currency from "../../../../../library/data-source/country-currency/Currency.bs.js";
import * as ReactModal from "react-modal";
import * as Button$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/Button.bs.js";
import * as Column$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Column.bs.js";
import * as FormInput$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as FormHelper$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as FormTitleBar$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormTitleBar.bs.js";
import * as FormTextInput$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormTextInput.bs.js";
import * as FormSelectInput$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormSelectInput.bs.js";
import * as EditWalletModalCmpMetaData from "./EditWalletModalCmpMetaData.bs.js";

function EditWalletModalCmp(Props) {
  var update_wallet_balance = Props.update_wallet_balance;
  var onCloseCb = Props.onCloseCb;
  var match = React.useState(function () {
        return "";
      });
  var setUpdateAmount = match[1];
  var update_amount = match[0];
  var match$1 = React.useState(function () {
        return "-1";
      });
  var setReason = match$1[1];
  var reason = match$1[0];
  var match$2 = React.useState(function () {
        return "";
      });
  var setComments = match$2[1];
  var comments = match$2[0];
  var match$3 = React.useState(function () {
        return false;
      });
  var setAmountError = match$3[1];
  var match$4 = React.useState(function () {
        return false;
      });
  var setReasonError = match$4[1];
  var match$5 = React.useState(function () {
        return false;
      });
  var setCommentsError = match$5[1];
  return React.createElement(ReactModal, {
              isOpen: true,
              style: EditWalletModalCmpMetaData.custom_modal_styles,
              ariaHideApp: false,
              shouldCloseOnOverlayClick: true,
              children: React.createElement("div", {
                    className: "edit-wallet-container"
                  }, React.createElement(FormTitleBar$Catalyst.make, {
                        title: "Wallet Balance",
                        onCloseCb: onCloseCb
                      }), React.createElement("form", {
                        className: "edit-wallet-form"
                      }, React.createElement(Column$Catalyst.make, {
                            children: null
                          }, React.createElement("div", {
                                className: "amount-label"
                              }, "Enter amount to be updated"), React.createElement(FormTextInput$Catalyst.make, {
                                input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                        var value = FormHelper$Catalyst.TargetEventWrapper.value($$event);
                                        return Curry._1(setUpdateAmount, (function (param) {
                                                      return value;
                                                    }));
                                      }), undefined, undefined, "Enter the number", undefined, undefined, undefined, match$3[0] ? ({
                                          TAG: /* Error */1,
                                          _0: "Enter amount bwetween -100000.00 to 100000.00"
                                        }) : ({
                                          TAG: /* Ok */0,
                                          _0: ""
                                        }), undefined, "amount-input", undefined, undefined, {
                                      className: "",
                                      startAdornment: "",
                                      accept: undefined
                                    }, undefined, undefined, undefined, undefined),
                                textinput_props: {
                                  value: update_amount
                                }
                              })), React.createElement(Column$Catalyst.make, {
                            children: null
                          }, React.createElement("div", {
                                className: "reason-label"
                              }, "Reason"), React.createElement(FormSelectInput$Catalyst.make, {
                                input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                        var value = FormHelper$Catalyst.TargetEventWrapper.value($$event);
                                        return Curry._1(setReason, (function (param) {
                                                      return value;
                                                    }));
                                      }), undefined, undefined, "Select the reason", undefined, undefined, undefined, match$4[0] ? ({
                                          TAG: /* Error */1,
                                          _0: "Please select a reason"
                                        }) : ({
                                          TAG: /* Ok */0,
                                          _0: ""
                                        }), undefined, "reason-input", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                select_props: {
                                  value: EditWalletModalCmpMetaData.getSelectedItem(reason),
                                  items: EditWalletModalCmpMetaData.reason_items,
                                  isNoneRequired: false
                                }
                              })), React.createElement(Column$Catalyst.make, {
                            children: null
                          }, React.createElement("div", {
                                className: "comments-label"
                              }, "Comments (Optional) "), React.createElement("textarea", {
                                className: "comments-textarea",
                                placeholder: "Enter your comments",
                                value: comments,
                                onChange: (function ($$event) {
                                    var value = FormHelper$Catalyst.TargetEventWrapper.value($$event);
                                    return Curry._1(setComments, (function (param) {
                                                  return value;
                                                }));
                                  })
                              }), match$5[0] ? React.createElement("div", {
                                  className: "comments-error"
                                }, "Can not be empty!") : null)), React.createElement("div", {
                        className: "form-footer"
                      }, React.createElement(Button$Catalyst.make, {
                            text: "Save",
                            cb: (function (param) {
                                var match = EditWalletModalCmpMetaData.update_amount_regex.test(update_amount);
                                var match$1 = reason !== "-1";
                                var match$2 = comments.length !== 0;
                                if (match && match$1 && match$2) {
                                  Curry._1(update_wallet_balance, Currency.fromString(update_amount));
                                  return Curry._1(onCloseCb, undefined);
                                }
                                if (match) {
                                  Curry._1(setAmountError, (function (param) {
                                          return false;
                                        }));
                                } else {
                                  Curry._1(setAmountError, (function (param) {
                                          return true;
                                        }));
                                }
                                if (match$1) {
                                  Curry._1(setReasonError, (function (param) {
                                          return false;
                                        }));
                                } else {
                                  Curry._1(setReasonError, (function (param) {
                                          return true;
                                        }));
                                }
                                if (match$2) {
                                  return Curry._1(setCommentsError, (function (param) {
                                                return false;
                                              }));
                                } else {
                                  return Curry._1(setCommentsError, (function (param) {
                                                return true;
                                              }));
                                }
                              }),
                            className: "save-btn btn-secondary"
                          })))
            });
}

var make = EditWalletModalCmp;

export {
  make ,
  
}
/* react Not a pure module */
